import BaseService from './BaseService'
import api from './api'
import {toast} from '../util/decorators'

export default class CategoryService extends BaseService {
  constructor () {
    super({
      roots: [],
      all: [],
      priest: [],
      bible: []
    })
  }

  get roots () {
    return this.data.roots
  }

  get all () {
    return this.data.all
  }

  get priest () {
    return this.data.priest
  }

  get bible () {
    return this.data.bible
  }

  @toast()
  async loadRootCategories () {
    if (this.data.roots.length === 0) {
      this.data.roots = await api.category.getPage()
    }
  }

  @toast()
  async loadAllCategories () {
    if (this.data.all.length === 0) {
      this.data.all = await api.category.getAll()
    }
  }

  @toast('获取牧者列表失败')
  async loadPriests () {
    if (this.data.priest.length === 0) {
      this.data.priest = await api.category.getMZZL()
    }
  }

  @toast()
  async loadBible () {
    if (this.data.bible.length === 0) {
      this.data.bible = await api.category.getBible()
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/CategoryService.js